export enum PaymentStatus {
  INVALID = 'INVALID',
  PENDING = 'PENDING',
  VALID = 'VALID',
}
